import { writable } from 'svelte/store';

export const course_id = writable("");